"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.roCountry = void 0;
var _utils = require("../utils");
// i18next-extract-mark-ns-start Countries

var roCountry = exports.roCountry = function roCountry(t) {
  return {
    id: 'RO',
    name: t('Romania'),
    flag: '🇷🇴',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      var regex = /^[0-9]{6}$/;
      return regex.test(zipcode);
    },
    zipcodeMatcher: _utils.defaultZipcodeMatcher,
    zipcodePlaceholder: 'e.g. 010101 or 400000',
    phonePrefix: '40',
    phoneLength: 9,
    pricingVersion: 14,
    timezone: 'Europe/Bucharest',
    currency: 'EUR'
  };
};